import styled from 'styled-components'
import PropTypes from 'prop-types'

import { ColumnLeft } from './columnLeft'
import { ColumnRight } from './columnRight'
import { gap as defaultGap } from './defaults'
import { getAppliedSlots } from './getAppliedSlots'

const gridArea = 'cols'
const Wrap = styled.div`
  grid-area: ${gridArea};
  display: grid;
  grid-template-columns: repeat(12, 1fr);
  grid-auto-rows: auto;
  column-gap: ${({ gap }) => gap};
  background-color: ${({ bgColor }) => bgColor};
`
const Columns = ({ children, bgColor = 'white', gap = defaultGap, ...rest }) => {
  return (
    <Wrap bgColor={bgColor} gap={gap} {...rest}>
      {children}
    </Wrap>
  )
}

Columns.propTypes = {
  gap: PropTypes.string,
  bgColor: PropTypes.string,
  /** @ignore Storybook control */
  children: props => {
    const applied = getAppliedSlots(props.children)

    if (
      applied[0] !== ColumnLeft.slotName ||
      applied[1] !== ColumnRight.slotName ||
      applied.length !== 2
    ) {
      return new Error(
        `Invalid \`children\` applied to Page.Columns. Children found:\n${applied.toString()}`
      )
    }
  }
}
Columns.slotName = 'PageColumns'

export { Columns, gridArea }
